import React, { useEffect, useState } from "react";
import InputPassword from "../ReusableComponents/InputPassword";
import toast from "react-hot-toast";
import { IUDAPI } from "../services/APIConnection";
import { mainTable } from "../css/Common";

const ResetPassword = ({ closePopup, data }) => {
  const [password, setPassword] = useState("");
  const [passwordError, setPasswordError] = useState("");
  const [reEnterPassword, setReEnterPassword] = useState("");
  const [reEnterPasswordError, setReEnterPasswordError] = useState("");
  const [passwordMatchError, setPasswordMatchError] = useState("");
  const [passwordMatch, setPasswordMatch] = useState(true);
  const [userName, setUserName] = useState("");
  const [disabledBtn, setDisabledBtn] = useState(false);

  useEffect(() => {
    if (data) {
      setUserName(data.UserEmail || data.UserMobile);
    }
  }, [data]);

  const validatePassword = (value) => {
    return /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^A-Za-z\d])[A-Za-z\d\S]{8,30}$/.test(
      value
    );
  };

  const cancel = () => {
    closePopup(true);
    setPassword("");
    setReEnterPassword("");
    setPasswordError("");
    setReEnterPasswordError("");
    setPasswordMatchError("");
    setPasswordMatch(true);
    setDisabledBtn(false);
  };

  const handleBlurPassword = (value) => {
    setPassword(value);
    if (!value) {
      setPasswordError("Enter Password");
    } else if (!validatePassword(value)) {
      setPasswordError(
        "Password must have 8-30 characters including uppercase, lowercase, number, and special character"
      );
    } else {
      setPasswordError("");
    }
  };

  const handleBlurReEnterPassword = (value) => {
    setReEnterPassword(value);
    if (!value) {
      setReEnterPasswordError("Re-enter password");
      setPasswordMatch(true);
    } 
    else if(value && password !== value){
setReEnterPasswordError("Passwords do not match");
    }
    else {
      setReEnterPasswordError("");
      setPasswordMatch(password === value);
    }
  };

  const ResetSubmit = async () => {
    let hasError = false;

    // Validation
    if (!password) {
      setPasswordError("Enter Password");
      hasError = true;
    } else if (!validatePassword(password)) {
      setPasswordError(
        "Password must have 8-30 characters including uppercase, lowercase, number, and special character"
      );
      hasError = true;
    } else {
      setPasswordError("");
    }

    if (!reEnterPassword) {
      setReEnterPasswordError("Re-enter password");
      hasError = true;
    } else {
      setReEnterPasswordError("");
    }

    if (password !== reEnterPassword) {
      setPasswordMatchError("Passwords do not match");
      hasError = true;
    } else {
      setPasswordMatchError("");
    }

    if (hasError) {
      setDisabledBtn(false);
      return;
    }

    try {
      setDisabledBtn(true);
      const resetPayload = [
        { userName, password, tempPassword: reEnterPassword },
      ];
      const response = await IUDAPI(resetPayload, "UserAPI/ResetPassword");

      if (response?.data?.Table[0]?.Result === "R") {
        toast.success(
          "Password Reset Completed. You can now use your new password.",
          {
            duration: 1500,
            position: "top-center",
          }
        );
        setTimeout(cancel, 2000);
      } else {
        toast.error("Password Reset Not Completed", {
          duration: 2000,
          position: "top-center",
        });
        setTimeout(cancel, 2000);
      }
    } catch (error) {
      toast.error("Something went wrong. Please try again.", {
        duration: 2000,
        position: "top-center",
      });
      setDisabledBtn(false);
    }
  };

  return (
    <div className="w-full">
      <div className="text-xl mx-4 font-medium text-neutral-700 mb-4">
        Reset Your Password
      </div>

      <form className="mx-4">
        <div className="flex flex-col w-full">
          <div className="grid gap-4 mb-6">
            <InputPassword
              title="New password"
              classStar="text-red-400"
              name="password"
              maxLength={30}
              placeholder="Enter new password"
              content={password}
              controlFunc={(e) => setPassword(e.target.value)}
              controlFuncBlur={(e) => handleBlurPassword(e.target.value)}
            />
            {passwordError && (
              <span className="text-red-500">{passwordError}</span>
            )}

            <InputPassword
              title="Re-enter new password"
              classStar="text-red-400"
              name="reEnterPassword"
              placeholder="Re-enter new password"
              maxLength={30}
              content={reEnterPassword}
              controlFunc={(e) => setReEnterPassword(e.target.value)}
              controlFuncBlur={(e) => handleBlurReEnterPassword(e.target.value)}
            />
            {reEnterPasswordError && (
              <span className="text-red-500">{reEnterPasswordError}</span>
            )}
            {/* {!reEnterPasswordError && !passwordMatch && (
              <span className="text-red-500">Passwords do not match</span>
            )} */}
            {passwordMatchError && (
              <span className="text-red-500">{passwordMatchError}</span>
            )}

            <div className={mainTable.submitCancelMainDiv}>
              <button
                type="button"
                className={
                  disabledBtn
                    ? mainTable.disabledSubmitButton
                    : mainTable.submitButton
                }
                onClick={ResetSubmit}
                disabled={disabledBtn}
              >
                Save New Password
              </button>

              <button
                type="button"
                className={mainTable.cancelButton}
                onClick={cancel}
              >
                CANCEL
              </button>
            </div>
          </div>
        </div>
      </form>
    </div>
  );
};

export default ResetPassword;
